import api from './api';

export async function cancelRequest(requestId) {
  try {
    const { data } = await api.delete(`/requests/${requestId}/cancel`);

    return data;
  } catch {
    return null;
  }
}
